import { defineMessages } from 'react-intl';

/**
 * Intl message for the Restart action in the bottom action row. Shared by the
 * Estimate (step 3) and Summary (step 5) screens, which render the same button
 * (GWP-12674 replaced the old Back link with Restart on both).
 */
export const messages = defineMessages({
	restart: {
		id: 'ubp.calculator.restart',
		defaultMessage: 'Restart',
	},
});
